import { Injectable, signal, computed } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Feed } from '../../interfaces/feed.model';
// import { Feed } from '../../interfaces/feed.model';

@Injectable({
  providedIn: 'root'
})
export class FeedService {
  private feedsSubject = new BehaviorSubject<Feed[]>([]);
  public feeds$ = this.feedsSubject.asObservable();
  
  private feedsSignal = signal<Feed[]>([]);
  public feeds = this.feedsSignal.asReadonly();
  
  constructor() {}
  
  getFeeds(): Observable<Feed[]> {
    return this.feeds$;
  }
  
  addFeed(feed: Feed): void {
    const currentFeeds = this.feedsSubject.value;
    this.feedsSubject.next([...currentFeeds, feed]);
    this.feedsSignal.set([...this.feedsSignal(), feed]);
  }
  
  deleteFeed(feedId: string): void {
    const currentFeeds = this.feedsSubject.value.filter(feed => feed.id !== feedId);
    this.feedsSubject.next(currentFeeds);
    this.feedsSignal.set(currentFeeds);
  }
  
  updateFeed(feedId: string, updates: Partial<Feed>): void {
    const currentFeeds = this.feedsSubject.value.map(feed => 
      feed.id === feedId ? { ...feed, ...updates } : feed
    );
    this.feedsSubject.next(currentFeeds);
    this.feedsSignal.set(currentFeeds);
  }
  
  toggleFeedState(feedId: string): void {
    const feed = this.feedsSubject.value.find(f => f.id === feedId);
    if (feed) {
      if (feed.running) {
        feed.stop();
      } else {
        feed.start();
      }
      this.updateFeed(feedId, { running: !feed.running });
    }
  }
}